import createMuiTheme, { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { defaultsDeep } from 'lodash';

const theme = createMuiTheme();

const defaultOptions: ThemeOptions = {
  typography: {
    fontFamily: 'Open Sans',
    body1: {
      fontSize: theme.typography.pxToRem(15),
    },
  },
  palette: {
    background: {
      default: '#FFFFFF',
    },
    // Header, outbound messages, primary buttons, ...
    primary: {
      main: '#0078BD',
    },
    // Inbound messages, secondary buttons, ...
    secondary: {
      main: '#E9EFF0',
    },
    text: {
      // Powered by
      secondary: '#9e9e9e',
    },
  },
  overrides: {
    MuiInput: {
      input: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    LumaSvgIconWrapper: {
      default: {
        color: '#000000',
      },
    },
  },
};

// TODO: Move to BE once we've all default theme values defined.
// E.g.: default secondary/tertiary colors, typographies, shadows, etc
const getThemePropsLumaBot = (extendedOptions: ThemeOptions = {}): ThemeOptions =>
  defaultsDeep({}, extendedOptions, defaultOptions);

export default getThemePropsLumaBot;
